import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader2 } from 'lucide-react';
const variantClasses = {
    primary: 'bg-icavi-600 hover:bg-icavi-700 text-white border border-transparent shadow-sm focus:ring-icavi-500 dark:focus:ring-icavi-400',
    secondary: 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 shadow-sm focus:ring-icavi-500 dark:focus:ring-icavi-400',
    outline: 'bg-transparent border border-icavi-500 text-icavi-600 dark:border-icavi-300 dark:text-icavi-200 hover:bg-icavi-500 hover:text-white dark:hover:bg-icavi-500 dark:hover:text-white focus:ring-icavi-500',
    ghost: 'bg-transparent border border-transparent text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 focus:ring-gray-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white border border-transparent shadow-sm focus:ring-red-500',
    success: 'bg-green-600 hover:bg-green-700 text-white border border-transparent shadow-sm focus:ring-green-500',
    warning: 'bg-yellow-500 hover:bg-yellow-600 text-gray-900 border border-transparent shadow-sm focus:ring-yellow-500',
};
const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg',
};
const iconOnlyClasses = {
    xs: 'p-1',
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-3',
    xl: 'p-4',
};
const iconSizeClasses = {
    xs: 'h-3.5 w-3.5',
    sm: 'h-4 w-4',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
    xl: 'h-6 w-6',
};
const baseClasses = 'inline-flex items-center justify-center gap-2 font-medium rounded whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed';
const Button = ({ children, className = '', variant = 'primary', size = 'md', loading = false, disabled, icon: Icon, iconPosition = 'left', fullWidth = false, iconOnly = false, type = 'button', ...rest }) => {
    // `loading` sempre desabilita, mesmo com `disabled={false}` explícito: nunca dois envios da mesma ação.
    const isDisabled = Boolean(disabled) || loading;
    return (_jsxs("button", { type: type, className: [
            baseClasses,
            variantClasses[variant],
            iconOnly ? iconOnlyClasses[size] : sizeClasses[size],
            fullWidth ? 'w-full' : '',
            className,
        ]
            .filter(Boolean)
            .join(' '), disabled: isDisabled, "aria-busy": loading || undefined, ...rest, children: [loading && (_jsx(Loader2, { className: `${iconSizeClasses[size]} animate-spin`, "aria-hidden": "true" })), !loading && Icon && iconPosition === 'left' && (_jsx(Icon, { className: iconSizeClasses[size], "aria-hidden": "true" })), children, !loading && Icon && iconPosition === 'right' && (_jsx(Icon, { className: iconSizeClasses[size], "aria-hidden": "true" }))] }));
};
export { Button };
export default Button;
